<template>
    <section>
    <div class="ibox">
        <div class="ibox-content">
            <table class="table table-striped table-responsive table-bordered table-hover" id="subscriptionDtTable">
                <thead>
                    <tr>
                        <th>Id</th>
                        <th>Subscription</th>
                        <th>Started</th>
                        <th>Ended</th>
                        <th>Status</th>
                        <th class="text-center"><i class="fa fa-bolt"></i></th>
                    </tr>
                </thead>
                <tbody></tbody>
            </table>            
        </div>
    </div>
    </section>
</template>

<script>
    export default {
        name: "SubscriptionHistory",
        props:["selectedRestaurant"],
        data () {
            return {
                dtTable:''
            }
        },
        computed:{
            userRole(){
                return this.$store.state.user.userRolesById[0].role;
            }
        },
        watch:{
            selectedRestaurant(){
                this.dtTable.draw();
            }
        },
        mounted: function(){
            this.populateDatatable();
        },          
        methods:{
            populateDatatable: function(){
                let self = this;
                let processingURL = this.$store.state.mainAppURL + "billings/get_all_subscriptions_of_restaurant_with_pagination";
                self.dtTable = $('#subscriptionDtTable').DataTable({
                    "processing": true,
                    "serverSide": true,
                    "searching": true,
                    "lengthMenu": [10, 25, 50, 100, 250],
                    "dom":'ltipr',
                    "initComplete": function () {
                    var api = this.api();
                    api.column(0).visible( false );
                    if ( self.userRole!=='ROLE_ADMIN' ) {
                        api.column(4).visible( false );
                        api.column(5).visible( false );
                    }},
                    autoWidth: false,
                    "order": [[0, "desc"]],
                    'language': {
                        'processing': '<div class="sk-spinner sk-spinner-double-bounce">\n' +
                            '                <div class="sk-double-bounce1"></div>\n' +
                            '                <div class="sk-double-bounce2"></div>\n' +
                            '              </div>'
                    },
                    "ajax": {
                        url: processingURL,
                        type: "post",
                        data: function ( d ) {
                            Object.assign(d, {restaurant_id: self.selectedRestaurant.id});
                            return JSON.stringify( d );
                        },
                        headers: {
                            "Content-type": "application/json; charset=utf-8"
                        },
                        beforeSend:  (xhr) => {
                            xhr.setRequestHeader('Authorization', 'Bearer ' + this.$store.state.accessToken);
                        },
                        statusCode: {
                          401: () => {
                            this.updateRefreshTokenInDataTable(this.dtTable);
                          }
                        }
                    },
                    "columnDefs": [
                        { "orderable": false, "targets": [0,1,2,3,4,5] },
                        { 'className': "text-center", 'aTargets': [4]},
                    ],
                    "columns": [
                        { "data": "id","name":"id" },
                        { "data": "subscriptionName","name":"subscriptionName" },
                        {
                            "data": "started","name":"started",
                            "render": function(data) {
                                return "<span class='m_tip label label-default' title='"+self.$moment.parseZone(String(data)).local().format('DD/MM/YYYY hh:mm:ss A')+"'>"+self.$moment.parseZone(String(data)).local().format('DD/MM/YYYY hh:mm:ss A')+"</span>";
                            }
                        },
                        {
                            "data": "ended","name":"ended",
                            "render": function(data){
                                if(data!==null){
                                    return "<span class='m_tip label label-default' title='"+self.$moment.parseZone(String(data)).local().format('DD/MM/YYYY hh:mm:ss A')+"'>"+self.$moment.parseZone(String(data)).local().format('DD/MM/YYYY hh:mm:ss A')+"</span>";
                                }
                                return "N/A"
                            }
                        },
                        {
                            "data": "status", "name":"status",
                            "render": function(data, type, row){
                                return "<span class= 'label " + self.$parent.getClass(data) +"'>" + data+"</span>"
                            }
                        },
                        {
                            "data": "actions", "name":"actions",
                            "render": function(data, type, row){
                                if(row.ended===null){
                                    return '<a data-id="'+row.id+'" class="btn btn-xs btn-primary end_subscription" href="javascript:void(0)">End Subscription</a>';
                                }else{
                                    return '<a data-id="'+row.id+'" class="btn btn-xs btn-primary end_subscription disabled" href="javascript:void(0)">End Subscription</a>';
                                }
                                
                            }
                        }                    
                    ],
                    "drawCallback": function( settings ) {
                        $(".m_tip").tooltip();
                        $(".end_subscription").click(function () {
                            let subscriptionId = $(this).attr("data-id");
                            self.$parent.endSubscription(subscriptionId);
                            self.dtTable.draw();
                        });
                    },
                    "tableTools": {
                        "sSwfPath": "js/plugins/dataTables/swf/copy_csv_xls_pdf.swf"
                    }
                });
            }
        }
        
    }
</script>